import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

/**
 * Returns a validator that checks that the length of the text is within the
 * bounds of an option low and high value. Note the text being checked is
 * run through _.trim, so be sure to do that when saving the data as well.
 *
 * @param {Object} opts
 * @param {Number} opts.low the minimum length of the text
 * @param {Number} opts.high the maximum length of the text
 */
function inputLengthValidatorFactory(opts={}) {
	function inputLengthValidator(val) {
		if (_.isEmpty(val)) {
			return
		}
		if (_.isEmpty(opts) || (!opts.low && !opts.high)) {
			return
		}
		let inputLength = _.trim(val).length
		if (opts.low && inputLength < opts.low) {
			return i18n.get('forms.widgets.inputValidation.tooShort')
		}
		if (opts.high && inputLength > opts.high) {
			return i18n.get('forms.widgets.inputValidation.tooLong')
		}
	}
	return inputLengthValidator
}

export default inputLengthValidatorFactory

inputLengthValidatorFactory.__filename__ = 'components/validators/input-length-validator-factory.js'
